import { Link } from 'react-router-dom';
import { Panel } from '@/components/ui/Panel';

export default function NotFoundPage() {
  return (
    <Panel padding="loose" className="max-w-prose">
      <p className="eyebrow">Ошибка 404</p>
      <h1 className="mt-2 text-xl font-semibold tracking-tight text-fg">Такой страницы нет</h1>
      <p className="mt-2 text-sm leading-normal text-fg-secondary">
        Возможно, ссылка устарела. С вашим аккаунтом и платежами ничего не произошло.
      </p>
      {/* Stacked on a phone with real 44px rows rather than expanded hit areas:
          two links wrapping onto adjacent lines would have overlapping targets,
          and the wrong one would win. */}
      <div className="mt-4 flex flex-col items-start gap-1 text-sm sm:flex-row sm:gap-6">
        <Link
          to="/traffic"
          className="focus-ring inline-flex min-h-11 items-center rounded-sm font-medium text-fg-accent underline underline-offset-2"
        >
          Перейти в «Трафик»
        </Link>
        <Link
          to="/dashboard"
          className="focus-ring inline-flex min-h-11 items-center rounded-sm font-medium text-fg-accent underline underline-offset-2"
        >
          Перейти в «Обзор»
        </Link>
      </div>
    </Panel>
  );
}
